import Vue from 'vue';
import DataUtils from 'src/utils/data';
export default Vue.extend({
    props: {
        dateFieldIndex: { type: Object, default: () => ({}) },
        conceptColours: { type: Object, required: true },
        savedQueries: { type: Array, required: true },
        firstRow: { type: Boolean, default: false },
        query: { type: Object, required: true },
    },
    computed: {
        isAllDataQuery() {
            // "all_data" queries are used for excludes and we don't want to display them. Don't render if we are one.
            return this.query['type'] === 'all_data';
        },
        isQuery() {
            return this.query.type === 'query';
        },
        canOr() {
            return ['is', 'is not', 'includes', 'does not include'].indexOf(this.query.operator) >= 0;
        },
        isAttribute() {
            return this.query.type === 'attribute';
        },
        isDate() {
            return !!(this.dateFieldIndex && this.isSegment && this.dateFieldIndex[this.query.field]);
        },
        isRange() {
            return this.query.operator.endsWith('in the range');
        },
        isSegment() {
            return this.query.type === 'segment';
        },
        // A view across query values that can include an empty pseudo-value
        pseudoValues() {
            // Check first for INVISIBLE queries, such as the "all data" query on a "does not include"
            if (this.query['type'] === 'all_data') {
                return;
            }
            let values = this.query.values;
            if (values && values.length === 0) {
                values = values.concat(undefined);
            }
            return values;
        },
    },
    methods: {
        formatDate: DataUtils.formatDate,
        // Does the specified OR `index` represent the last one?
        isLastOr(index) {
            return index + 1 === this.query.values.length;
        },
    }
});
